/* eslint-disable no-mixed-operators */
/* eslint-disable eqeqeq */
/* eslint-disable camelcase */
/* eslint-disable no-plusplus */

function validaCpf(cpf) {
  let numeros;
  let digitos;
  let soma;
  let i;
  let resultado;
  let digitosIguais;
  digitosIguais = 1;
  if (cpf.length < 11) return false;
  for (i = 0; i < cpf.length - 1; i++) {
    if (cpf.charAt(i) != cpf.charAt(i + 1)) {
      digitosIguais = 0;
      break;
    }
  }
  if (!digitosIguais) {
    numeros = cpf.substring(0, 9);
    digitos = cpf.substring(9);
    soma = 0;
    for (i = 10; i > 1; i--) soma += numeros.charAt(10 - i) * i;
    resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
    if (resultado != digitos.charAt(0)) return false;
    numeros = cpf.substring(0, 10);
    soma = 0;
    for (i = 11; i > 1; i--) soma += numeros.charAt(11 - i) * i;
    resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
    if (resultado != digitos.charAt(1)) return false;
    return true;
  }
  return false;
}

function validarCNPJ(cnpj) {
  cnpj = String(cnpj).replace(/\D/g, "");

  if (cnpj.length !== 14 || /^(\d)\1+$/.test(cnpj)) {
    return false;
  }

  // Valida DVs
  let tamanho = cnpj.length - 2;
  let numeros = cnpj.substring(0, tamanho);
  const digitos = cnpj.substring(tamanho);
  let soma = 0;
  let pos = tamanho - 7;
  for (let i = tamanho; i >= 1; i--) {
    soma += numeros.charAt(tamanho - i) * pos--;
    if (pos < 2) {
      pos = 9;
    }
  }
  let resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
  if (Number(resultado) !== Number(digitos.charAt(0))) {
    return false;
  }

  tamanho += 1;
  numeros = cnpj.substring(0, tamanho);
  soma = 0;
  pos = tamanho - 7;
  for (let i = tamanho; i >= 1; i--) {
    soma += numeros.charAt(tamanho - i) * pos--;
    if (pos < 2) {
      pos = 9;
    }
  }
  resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
  if (Number(resultado) !== Number(digitos.charAt(1))) {
    return false;
  }

  return true;
}

function isValidCnpjPortadorBusca(value) {
  if (
    !value ||
    (typeof value !== "string" && typeof value !== "number")
  ) {
    return false;
  }
  const core = String(value).toUpperCase().replace(/[^A-Z0-9]/g, "");
  if (core.length !== 14 || /^(.)\1+$/.test(core)) {
    return false;
  }
  if (/^[0-9]{14}$/.test(core)) {
    return validarCNPJ(core);
  }
  return /[A-Z]/.test(core);
}

const validsDDD = [
  "11",
  "12",
  "13",
  "14",
  "15",
  "16",
  "17",
  "18",
  "19",
  "21",
  "22",
  "24",
  "27",
  "28",
  "31",
  "32",
  "33",
  "34",
  "35",
  "37",
  "38",
  "41",
  "42",
  "43",
  "44",
  "45",
  "46",
  "47",
  "48",
  "49",
  "51",
  "53",
  "54",
  "55",
  "61",
  "62",
  "63",
  "64",
  "65",
  "66",
  "67",
  "68",
  "69",
  "71",
  "73",
  "74",
  "75",
  "77",
  "79",
  "81",
  "82",
  "83",
  "84",
  "85",
  "86",
  "87",
  "88",
  "89",
  "91",
  "92",
  "93",
  "94",
  "95",
  "96",
  "97",
  "98",
  "99",
];

function validaDDD(ddd) {
  const formattedDDD = ddd.replace(/[^\d]+/g, "");

  if (!formattedDDD || formattedDDD.length !== 2) {
    return false;
  }

  return validsDDD.includes(formattedDDD);
}

function validaRg(rg) {
  let i;
  let digitosIguais;
  digitosIguais = 1;
  if (rg.length < 7 || rg.length > 11) return false;
  for (i = 0; i < rg.length - 1; i++) {
    if (rg.charAt(i) != rg.charAt(i + 1)) {
      digitosIguais = 0;
      break;
    }
  }
  if (!digitosIguais) {
    return true;
  }
  return false;
}

function isCustomError(response) {
  return (
    !!response?.statusCode &&
    typeof response.statusCode === "number" &&
    response?.statusCode?.toString()[0] !== "2"
  );
}

export {
  validaCpf,
  validarCNPJ,
  isValidCnpjPortadorBusca,
  validaDDD,
  validaRg,
  isCustomError,
};
